export function blogSearch()
{
	const clearBtn = document.querySelector('.post-archive__search-clear');

	if (!clearBtn) {
		return;
	}

	clearBtn.addEventListener('click', () => {
		const form = clearBtn.closest('form');
		const field = form.querySelector('input');
		field.value = '';
		form.submit();
	});
}


// WEBPACK FOOTER //
// ./scripts/modules/blog.js